import { render, staticRenderFns } from "./SelfSignupForm.vue?vue&type=template&id=60329798&scoped=true&"
import script from "./SelfSignupForm.vue?vue&type=script&lang=js&"
export * from "./SelfSignupForm.vue?vue&type=script&lang=js&"
import style0 from "./SelfSignupForm.vue?vue&type=style&index=0&id=60329798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60329798",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
